import { createApp } from 'vue';
import GifToPngConverter from '../Components/GifToPngConverter.vue';

const root = document.getElementById('gif-to-png-converter');
if (root) {
  createApp(GifToPngConverter).mount('#gif-to-png-converter');
}
